import { on } from 'delegated-events'
import { setupForm } from '@components/styled-form'
import '@styles/components/modal-subscribe.css'
import '@components/styled-form.css'

const handleVisibleFields = (el) => {
  const form = el.querySelector('form')
  const fields = form.querySelector('.publication-fields')

  const checked = Array.from(form.querySelectorAll(`#SubscribeForm_SubscribeForm_Types input:checked`))

  const showAllFields = checked.some(
    (input) => input.id === 'SubscribeForm_SubscribeForm_Types_App_Publication_Publication-1'
  )

  if (showAllFields) {
    fields.classList.remove('hidden')
  } else {
    fields.classList.add('hidden')
    fields.querySelectorAll('input:not([type=checkbox]):not([type=radio])').forEach((x) => (x.value = null))
    fields.querySelectorAll('select').forEach((x) => (x.value = null))
  }
}

export default {
  init: (el) => {
    setupForm(el.querySelector('form'))

    on('change', `#${el.id} #SubscribeForm_SubscribeForm_Types input[type="checkbox"]`, () => handleVisibleFields(el))

    handleVisibleFields(el)
  },
}
